import { FormStepper } from '@diamond/sol-admin/components';

const steps = [
  { title: 'Informasi Resep' },
  { title: 'Deskripsi' },
  { title: 'Bahan & Produk' },
  { title: 'Instruksi Memasak' },
];

export function RecipeStepper({ currentIndex }: { currentIndex: number }) {
  return (
    <FormStepper
      steps={steps}
      currentStep={currentIndex}
      containerProps={{ maxW: 'container.lg', mx: 'auto' }}
    />
  );
}
